/** Traductions page restaurant / cuisine (FR / AR) */
export const restaurantPageFr = {
  reservedForRestaurants: 'Cette page est réservée aux restaurants.',
  productQtyRequired: 'Produit et quantité valides requis',
  insufficientStock: 'Stock insuffisant (disponible : {{available}})',
  addAtLeastOneProduct: 'Ajoutez au moins un produit',
  failed: 'Échec',
  consumptionSaved: 'Retrait extra enregistré',
  error: 'Erreur',
  pageTitle: 'Restaurant — recettes & cuisine',
  pageSubtitle:
    'Recettes actives = FIFO à la vente POS. Production = BOM multi-ingrédients → lots produit fini. Lieux : Bar, Cuisine, Grill. Retrait cuisine = extra.',
  locationsActivated: 'Lieux stock activés : Bar, Cuisine, Grill',
  tabConsumption: 'Retrait extra (cuisine)',
  tabRecipes: 'Recettes',
  tabHistory: 'Historique',
  tabProduction: 'Production',
  prodHint:
    'Production restaurant : la formule (recette) peut contenir plusieurs ingrédients et sous-recettes. Échelle = nombre de formules OU quantité de produit fini stockable — ce n’est pas une vente de portions POS. FIFO consomme chaque ligne d’ingrédient, puis crée un lot de sortie (sauce, fond, pâte…).',
  prodRecipe: 'Formule / recette (BOM multi-ingrédients)',
  prodSelectRecipe: 'Choisissez une recette',
  prodSelectRecipeOption: '— Recette (plusieurs composantes) —',
  prodIngShort: 'composantes',
  prodBomMeta: 'BOM : {{count}} ligne(s) · base formule = {{formula}}',
  prodFinishedProduct: 'Produit fini stockable (sortie)',
  prodSelectFinishedOption: '— Article / semi-ouvré —',
  prodFinishedStockable:
    'Le produit fini doit être stockable (pas un plat menu seul). Créez un article cuisine comme sortie.',
  prodRecipeMustBeActive: 'La recette doit être ACTIVE',
  prodScaleMode: 'Échelle matière',
  prodScaleBatches: 'Par nombre de formules (× BOM entière)',
  prodScaleOutput: 'Par quantité de produit fini (proportionalise la BOM)',
  prodBatches: 'Nombre de formules à lancer',
  prodFormulaOutput: 'Sortie attendue par formule (unité stock PF)',
  prodFormulaOutputHint: 'ex. 1 formule → 5 kg sauce',
  prodOutputQty: 'Quantité produit fini à stocker',
  prodBatch: 'N° lot / batch production',
  prodBatchPlaceholder: 'Auto si vide',
  prodExpiry: 'DLC produit fini',
  prodComponentPreview: 'Ingrédients à consommer (FIFO)',
  prodScaleSummary: '{{batches}}× formule · {{lines}} ligne(s) stock',
  prodColUnit: 'Unité',
  prodConfirm: 'Lancer la production',
  prodCompleted: 'Production enregistrée (lots mis à jour)',
  prodHistory: 'Historique de production',
  prodEmpty: 'Aucune production encore',
  prodStatRuns: 'Runs terminés',
  prodColWhen: 'Date',
  prodColProduct: 'Produit fini',
  prodColComponents: 'Compos.',
  prodColQty: 'Qté / formules',
  prodColCost: 'Coût matières',
  prodColBatch: 'Lot',
  dateLabel: 'Date',
  noteLabel: 'Note (prep, perte, correction…)',
  ingredientPlaceholder: '— Ingrédient stock —',
  quantityPlaceholder: 'Quantité (unité stock)',
  add: 'Ajouter',
  productCol: 'Produit',
  qtyCol: 'Qté',
  submitting: '…',
  confirmConsumption: 'Valider le retrait extra',
  consumptionHint:
    'Ce retrait abaisse les lots du lieu choisi (Bar, Cuisine, Grill). Les plats vendus au POS consomment déjà leurs recettes à l’emplacement stock de chaque ingrédient — n’utilisez ce formulaire que pour prep / pertes / corrections.',
  locationLabel: 'Lieu stock',
  locationCol: 'Lieu',
  dishSalesTitle: 'Ventes menu (QuickSale)',
  dishSalesSubtitle:
    'Plats → recettes + FIFO. Boissons stock (sellOnPos) → lot du produit. Cuisine = extra uniquement.',
  statSales: 'Ventes',
  statPiecesSold: 'Pièces vendues',
  statMenuDrinks: 'Boissons menu',
  statFoodRest: 'Plats / reste',
  statRevenue: 'Chiffre',
  topSold: 'Les plus vendus',
  noSales: 'Aucune vente',
  kitchenWithdrawals: 'Retraits cuisine (extra)',
  noWithdrawals: 'Aucun retrait extra',
  recipeHint:
    'Une seule recette active par plat. Vente POS = lots FIFO des ingrédients. Boissons en vente directe : sellOnPos, sans recette.',
  recipeFilterDish: 'Filtrer par plat',
  recipeAllDishes: '— Tous les plats —',
  recipeNew: 'Nouvelle recette',
  recipeListTitle: 'Recettes',
  recipeEmpty:
    'Aucune recette — créez-en une ou chargez un plat avec BOM héritée (migration auto).',
  recipeActiveForDish: 'Recette active',
  recipeEditorTitle: 'Éditeur de recette',
  recipeSelectOrCreate: 'Sélectionnez une recette ou créez-en une nouvelle.',
  recipeColName: 'Nom',
  recipeColDish: 'Plat',
  recipeColVersion: 'Version',
  recipeColStatus: 'Statut',
  recipeStatus_draft: 'Brouillon',
  recipeStatus_active: 'Active',
  recipeStatus_archived: 'Archivée',
  recipeName: 'Nom de la recette',
  recipeDish: 'Plat menu',
  recipeSelectDish: '— Choisir un plat —',
  recipeVersion: 'Version',
  recipeStatus: 'Statut',
  recipePortions: 'Base formule (unités BOM)',
  recipePortionsHint:
    'Unités pour lesquelles les quantités d’ingrédients sont écrites. POS = assiettes ; Production = base d’1 formule complète.',
  recipeYieldPct: 'Rendement %',
  recipePrepCost: 'Coût préparation (batch)',
  recipeSellingPrice: 'Prix de vente (portion)',
  recipeIngredients: 'Ingrédients',
  recipeIngKind: 'Type',
  recipeIngItem: 'Article',
  recipeIngQty: 'Qté',
  recipeIngUnit: 'Unité stock',
  recipeIngLoss: 'Perte %',
  recipeKindProduct: 'Ingrédient stock',
  recipeKindSub: 'Sous-recette',
  recipeSelectIngredient: '— Ingrédient —',
  recipeSelectSub: '— Sous-recette —',
  recipeUnitStock: 'Unité stock',
  recipeUnitLocked: 'Unité d’inventaire du produit (non modifiable)',
  recipeQtyInStockUnit: 'Quantité dans l’unité de stock du produit (ex. kg de viande)',
  recipeStockUnitHint:
    'Saisissez les quantités uniquement dans l’unité de stock du produit (ex. viande en kg → 0,08 pour 80 g). Même échelle que l’inventaire et le FIFO.',
  recipeStockMaxPortions: 'Portions restantes (stock)',
  recipeStockBottleneck: 'Ingrédient limitant',
  recipePortionsShort: 'unités BOM',
  recipeAddIngredient: 'Ajouter une ligne',
  recipeTheoreticalCost: 'Coût théorique / portion',
  recipeFoodCostPct: 'Food cost %',
  recipeCostNote:
    'Coût théorique d’après prix d’achat des lots (indicatif). Le coût réel à la vente = FIFO (inventoryCost). Qté recette = unité stock → déduction 1:1.',
  recipeSave: 'Enregistrer',
  recipeSaveActivate: 'Enregistrer et activer',
  recipeSaveDraft: 'Enregistrer brouillon',
  recipeSavedDraft: 'Brouillon enregistré (non utilisé au POS)',
  recipeDraftBanner:
    'Brouillon : le POS utilise uniquement la recette ACTIVE. Cliquez « Enregistrer et activer ».',
  recipeActivate: 'Activer',
  recipeArchive: 'Archiver',
  recipeNewVersion: 'Nouvelle version',
  recipeSaved: 'Recette enregistrée',
  recipeSavedActive: 'Recette enregistrée et activée (POS)',
  recipeActivated: 'Recette activée',
  recipeArchived: 'Recette archivée',
  recipeInvalid: 'Recette invalide',
  recipeSaveFailed: 'Impossible d’enregistrer la recette',
  storeLabel: 'Magasin (stock)',
  storeSwitched: 'Magasin actif : {{name}}',
  storeSwitchFailed: 'Impossible de changer de magasin'
};

export const restaurantPageAr = {
  reservedForRestaurants: 'هذه الصفحة مخصصة للمطاعم فقط.',
  productQtyRequired: 'المنتج والكمية مطلوبان',
  insufficientStock: 'المخزون غير كافٍ (المتوفر: {{available}})',
  addAtLeastOneProduct: 'أضف منتجاً واحداً على الأقل',
  failed: 'فشل',
  consumptionSaved: 'تم تسجيل السحب الإضافي',
  error: 'خطأ',
  pageTitle: 'المطعم — الوصفات والمطبخ',
  pageSubtitle:
    'الوصفة النشطة = FIFO عند البيع. الإنتاج = BOM بعدة مكوّنات → لوت منتج نهائي. المواقع: Bar و Cuisine و Grill. السحب = إضافي.',
  locationsActivated: 'تم تفعيل مواقع المخزون: Bar و Cuisine و Grill',
  tabConsumption: 'سحب إضافي (مطبخ)',
  tabRecipes: 'الوصفات',
  tabHistory: 'السجل',
  tabProduction: 'الإنتاج',
  prodHint:
    'إنتاج المطعم: الصيغة (الوصفة) قد تضم عدة مكوّنات ووصفات فرعية. المقياس = عدد الصيغ أو كمية المنتج النهائي — وليس حصص البيع. FIFO يخصم كل سطر ثم ينشئ لوت خروج.',
  prodRecipe: 'الصيغة / الوصفة (BOM بعدة مكوّنات)',
  prodSelectRecipe: 'اختر وصفة',
  prodSelectRecipeOption: '— وصفة (عدة مركّبات) —',
  prodIngShort: 'مركّبات',
  prodBomMeta: 'BOM: {{count}} سطر · قاعدة الصيغة = {{formula}}',
  prodFinishedProduct: 'منتج نهائي قابل للتخزين',
  prodSelectFinishedOption: '— صنف / نصف مصنع —',
  prodFinishedStockable:
    'المنتج النهائي يجب أن يكون مخزناً (ليس طبق قائمة فقط).',
  prodRecipeMustBeActive: 'يجب أن تكون الوصفة نشطة',
  prodScaleMode: 'مقياس المواد',
  prodScaleBatches: 'بعدد الصيغ (كامل BOM × N)',
  prodScaleOutput: 'بكمية المنتج النهائي (يتناسب BOM)',
  prodBatches: 'عدد الصيغ للتنفيذ',
  prodFormulaOutput: 'المخرج المتوقع لكل صيغة',
  prodFormulaOutputHint: 'مثال: 1 صيغة → 5 كغ صلصة',
  prodOutputQty: 'كمية المنتج النهائي للتخزين',
  prodBatch: 'رقم دفعة الإنتاج',
  prodBatchPlaceholder: 'تلقائي إن فُرغ',
  prodExpiry: 'صلاحية المنتج النهائي',
  prodComponentPreview: 'مكوّنات للاستهلاك (FIFO)',
  prodScaleSummary: '{{batches}}× صيغة · {{lines}} سطر مخزون',
  prodColUnit: 'الوحدة',
  prodConfirm: 'تنفيذ الإنتاج',
  prodCompleted: 'تم تسجيل الإنتاج',
  prodHistory: 'سجل الإنتاج',
  prodEmpty: 'لا إنتاج بعد',
  prodStatRuns: 'دورات مكتملة',
  prodColWhen: 'التاريخ',
  prodColProduct: 'المنتج النهائي',
  prodColComponents: 'مركّبات',
  prodColQty: 'كمية / صيغ',
  prodColCost: 'تكلفة المواد',
  prodColBatch: 'اللوت',
  dateLabel: 'التاريخ',
  noteLabel: 'ملاحظة (تحضير، هدر، تصحيح…)',
  ingredientPlaceholder: '— مكوّن مخزون —',
  quantityPlaceholder: 'الكمية (وحدة المخزون)',
  add: 'إضافة',
  productCol: 'المنتج',
  qtyCol: 'الكمية',
  submitting: '…',
  confirmConsumption: 'تأكيد السحب الإضافي',
  consumptionHint:
    'هذا السحب يخفض اللوتات في المكان المختار (Bar، Cuisine، Grill). الأطباق في نقطة البيع تستهلك وصفاتها حسب موقع كل مكوّن — استخدم هذا النموذج فقط للتحضير / الهدر / التصحيح.',
  locationLabel: 'موقع المخزون',
  locationCol: 'الموقع',
  dishSalesTitle: 'مبيعات القائمة (QuickSale)',
  dishSalesSubtitle:
    'أطباق → وصفات + FIFO. مشروبات stock (sellOnPos) → لوت المنتج. المطبخ = إضافي فقط.',
  statSales: 'عمليات',
  statPiecesSold: 'قطع مباعة',
  statMenuDrinks: 'مشروبات القائمة',
  statFoodRest: 'أطباق / باقي',
  statRevenue: 'المبلغ',
  topSold: 'الأكثر مبيعاً',
  noSales: 'لا مبيعات',
  kitchenWithdrawals: 'سحب المطبخ (إضافي)',
  noWithdrawals: 'لا سحب إضافي',
  recipeHint:
    'وصفة نشطة واحدة فقط لكل طبق. البيع = خصم FIFO للمكوّنات. البيع المباشر للمشروبات: sellOnPos بدون وصفة.',
  recipeFilterDish: 'تصفية حسب الطبق',
  recipeAllDishes: '— كل الأطباق —',
  recipeNew: 'وصفة جديدة',
  recipeListTitle: 'الوصفات',
  recipeEmpty:
    'لا وصفات — أنشئ واحدة أو حمّل طبقاً بـ BOM قديم (هجرة تلقائية).',
  recipeActiveForDish: 'الوصفة النشطة',
  recipeEditorTitle: 'محرر الوصفة',
  recipeSelectOrCreate: 'اختر وصفة أو أنشئ واحدة جديدة.',
  recipeColName: 'الاسم',
  recipeColDish: 'الطبق',
  recipeColVersion: 'الإصدار',
  recipeColStatus: 'الحالة',
  recipeStatus_draft: 'مسودة',
  recipeStatus_active: 'نشطة',
  recipeStatus_archived: 'مؤرشفة',
  recipeName: 'اسم الوصفة',
  recipeDish: 'طبق القائمة',
  recipeSelectDish: '— اختر طبقاً —',
  recipeVersion: 'الإصدار',
  recipeStatus: 'الحالة',
  recipePortions: 'أساس الصيغة (وحدات BOM)',
  recipePortionsHint:
    'الوحدات التي كُتبت لأجلها الكميات. نقطة البيع = أطباق؛ الإنتاج = أساس صيغة كاملة.',
  recipeYieldPct: 'المردود %',
  recipePrepCost: 'تكلفة التحضير (الدفعة)',
  recipeSellingPrice: 'سعر البيع (حصة)',
  recipeIngredients: 'المكوّنات',
  recipeIngKind: 'النوع',
  recipeIngItem: 'الصنف',
  recipeIngQty: 'الكمية',
  recipeIngUnit: 'وحدة المخزون',
  recipeIngLoss: 'هدر %',
  recipeKindProduct: 'مكوّن مخزون',
  recipeKindSub: 'وصفة فرعية',
  recipeSelectIngredient: '— مكوّن —',
  recipeSelectSub: '— وصفة فرعية —',
  recipeUnitStock: 'وحدة المخزون',
  recipeUnitLocked: 'وحدة مخزون المنتج (غير قابلة للتغيير)',
  recipeQtyInStockUnit: 'الكمية بوحدة مخزون المنتج (مثال: كغ لحم)',
  recipeStockUnitHint:
    'أدخل الكميات بوحدة المخزون فقط (مثال: لحم بالكغ → 0.08 لـ 80 غ). نفس مقياس المخزون و FIFO.',
  recipeStockMaxPortions: 'الحصص المتبقية (مخزون)',
  recipeStockBottleneck: 'المكوّن المحدّد',
  recipePortionsShort: 'وحدات BOM',
  recipeAddIngredient: 'إضافة سطر',
  recipeTheoreticalCost: 'التكلفة النظرية / حصة',
  recipeFoodCostPct: 'نسبة food cost',
  recipeCostNote:
    'تكلفة نظرية من أسعار الشراء. التكلفة الفعلية عند البيع = FIFO. كمية الوصفة = وحدة المخزون.',
  recipeSave: 'حفظ',
  recipeSaveActivate: 'حفظ وتفعيل',
  recipeSaveDraft: 'حفظ كمسودة',
  recipeSavedDraft: 'تم حفظ المسودة (لا تُستخدم في نقطة البيع)',
  recipeDraftBanner:
    'مسودة: نقطة البيع تستخدم فقط الوصفة النشطة. اضغط «حفظ وتفعيل».',
  recipeActivate: 'تفعيل',
  recipeArchive: 'أرشفة',
  recipeNewVersion: 'إصدار جديد',
  recipeSaved: 'تم حفظ الوصفة',
  recipeSavedActive: 'حُفظت وفعّلت الوصفة (نقطة البيع)',
  recipeActivated: 'تم تفعيل الوصفة',
  recipeArchived: 'تمت أرشفة الوصفة',
  recipeInvalid: 'وصفة غير صالحة',
  recipeSaveFailed: 'تعذّر حفظ الوصفة',
  storeLabel: 'المتجر (المخزون)',
  storeSwitched: 'المتجر النشط: {{name}}',
  storeSwitchFailed: 'تعذّر تغيير المتجر'
};
